import { Divider, Grid, Typography } from "@mui/material";
import { BtnAdd, BtnBack, BtnSave } from "components/Button/ButtonAll";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { AutoCompleteItem } from "components/Input/AutoComplete";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import SwitchFormItem from "components/Input/Switch";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { GridColumnGroupingModel } from "@mui/x-data-grid-pro";
import "./LeaveRights.css";
import InputNumberItem from "components/Input/InputNumber";
import { GetMenuPermission } from "utilities/SystemFunction";

const LeaveRightsForm = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const nYear = new URLSearchParams(searchParams).get('nYear');
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrUser, setArrUser] = useState([]);
    const [isEdit, setEdit] = useState(false);
    const [arrLeaveType, setarrLeaveType] = useState([]);
    const [dataColumLeave, setDataColumnLeave] = useState<any>([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sID",
        sSortDirection: "asc"
    });
    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            LeaveInsert: null,
        } as any,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const dataColumnSummary: any = [
        {
            field: 'sUserName',
            headerName: 'ชื่อ',
            headerAlign: 'center',
            minWidth: 360,
            sortable: false,
            align: "left",
            flex: 1
        }
    ];

    //merge tabel head
    const columnGroupingModel: GridColumnGroupingModel = [
        {
            groupId: "sLeave",
            headerName: "ประเภทการลา",
            children: [
                {
                    groupId: "ลาป่วย",
                    children: [{ field: "nLeaveAmount_" }, { field: "nLeaveRemain_" }],
                    headerAlign: "center",
                },
                {
                    groupId: "ลาพักผ่อน",
                    children: [{ field: "nVacaAmount_" }, { field: "nVacaBringForward_" }, { field: "nVacaRemain_" }],
                    headerAlign: "center",
                },
            ],
            headerAlign: "center"
        }
    ];

    const getTable = (p: PaginationInterface, sYear?: string) => {
        setLoadingTable(true);
        let param = {
            ...p,
            nYear: (+nYear - 543) > 0 ? (+nYear - 543) : nYear ?? +(sYear)
        }

        if (nYear !== null) {
            setEdit(true);
        }

        AxiosFn.Post(`LeaveRights/GetTableLeaveRightsForm`, param, (result) => {
            setArrUser(result.objResult.lstUserOption);
            setarrLeaveType(result.objResult.lstLeaveType);

            form.setValue("dYearPickerLeaveRights", result.objResult.sYear);
            form.setValue("statusLeaveRights", result.objResult.isActive);

            setDataRow({
                ...p,
                arrRows: result.lstLeaveRightsForm ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

            //set default value
            let arrResult = [];
            arrResult = result.lstLeaveRightsForm;
            arrResult.forEach(f => {
                f.lstLeaveType.forEach(item => {
                    form.setValue(`nLeaveAmount_${f.sID}_${item.nTypeID}`, item.nLeaveAmount);
                    form.setValue(`nLeaveRemain_${f.sID}_${item.nTypeID}`, item.nLeaveRemain);
                    form.setValue(`nVacaAmount_${f.sID}_${item.nTypeID}`, item.nLeaveAmount);
                    form.setValue(`nVacaBringForward_${f.sID}_${item.nTypeID}`, item.nVacaBringForward);
                    form.setValue(`nVacaRemain_${f.sID}_${item.nTypeID}`, item.nLeaveRemain);
                });
            });

            setLoadingTable(false);
        });
    };

    const onClearForm = () => {
        form.setValue("sUserNameSearch", null);
        form.setValue("LeaveInsert", null);
        form.setValue("VacaInsert", null);
        form.setValue("VacaLeaveDay", null);

        form.clearErrors();
    };

    const handleSubmit = (e, mode) => {
        //mode = 1: save
        //mode = 2: add new user    
        let param = {}
        if (mode === 1) {
            let array = [];
            array = dataRow.arrRows;
            array.forEach(f => {
                f.lstLeaveType.forEach(item => {
                    if (item.nUserID === f.nUserID) {
                        let nAllRemain = ((+e[`nVacaAmount_${f.sID}_2`] || item.nVacaAmount) + (+e[`nVacaBringForward_${f.sID}_2`] || item.nVacaBringForward) + (+e[`nVacaRemain_${f.sID}_2`] || item.nVacaRemain))
                        item.nID = f.nID;
                        item.sUserName = e[`sUserName`] || item.sUserName;
                        item.nTypeID = item.nTypeID;
                        item.nLeaveAmount = e[`nLeaveAmount_${f.sID}_1`] || null; //|| item.nLeaveAmount;
                        item.nLeaveRemain = e[`nLeaveRemain_${f.sID}_1`] || null; //|| item.nLeaveRemain;
                        item.nVacaAmount = e[`nVacaAmount_${f.sID}_2`] || null; //|| item.nVacaAmount;
                        item.nVacaBringForward = e[`nVacaBringForward_${f.sID}_2`] || null; //|| item.nVacaBringForward;
                        item.nVacaRemain = form.getValues(`nVacaRemain_${f.sID}_${item.nTypeID}`) || null;//|| item.nVacaRemain;
                    } else {
                        item.nID = f.nID;
                        item.sUserName = e[`sUserName`] || item.sUserName;
                        item.nTypeID = f.nTypeID;
                        item.nLeaveAmount = e[`nLeaveAmount_${f.sID}_1`] || null; //|| item.nLeaveAmount;
                        item.nLeaveRemain = e[`nLeaveRemain_${f.sID}_1`] || null; //|| item.nLeaveRemain;
                        item.nVacaAmount = e[`nVacaAmount_${f.sID}_2`] || null; //|| item.nVacaAmount;
                        item.nVacaBringForward = e[`nVacaBringForward_${f.sID}_2`] || null; //|| item.nVacaBringForward;
                        item.nVacaRemain = form.getValues(`nVacaRemain_${f.sID}_${item.nTypeID}`) || null;//|| item.nVacaRemain;
                    }
                });
            });

            param = {
                lstUserLeaveTable: array,
                nYear: nYear || 0,
                nDoubleYear: moment(form.getValues("dYearPickerLeaveRights")).valueOf(),
                nMode: mode,
                isActive: form.getValues("statusLeaveRights"),
                sLocation: location.pathname
            }
        } else if (mode === 2) {
            param = {
                lstUser: form.getValues("sUserNameSearch") === "" ? null : form.getValues("sUserNameSearch"),
                nLeaveInsert: form.getValues("LeaveInsert") === "" ? null : form.getValues("LeaveInsert"),
                nVacaInsert: form.getValues("VacaInsert") === "" ? null : form.getValues("VacaInsert"),
                nVacaBringForward: form.getValues("VacaLeaveDay") ?? 0,
                nYear: nYear || 0,
                nDoubleYear: moment(form.getValues("dYearPickerLeaveRights")).valueOf(),
                nMode: mode,
                isActive: form.getValues("statusLeaveRights"),
                sLocation: location.pathname,
                lstDataRow: dataRow.arrRows
            }
        }
        if (mode === 2) {
            if (form.getValues("sUserNameSearch") === null) {
                DialogFn.Warning("กรุณาเลือกพนักงานที่ต้องการเพิ่มสิทธิ์การลา");
            } else {
                AxiosFn.Post(`LeaveRights/OnSubmit`, param, (result) => {
                    let arrResult = [];
                    arrResult = result.objResult.lstDataRow

                    //set default value
                    arrResult.forEach(f => {
                        f.lstLeaveType.forEach(item => {
                            form.setValue(`sUserName`, f.sUserName)
                            form.setValue(`nLeaveAmount_${f.sID}_${item.nTypeID}`, item.nLeaveAmount);
                            form.setValue(`nLeaveRemain_${f.sID}_${item.nTypeID}`, item.nLeaveRemain);
                            form.setValue(`nVacaAmount_${f.sID}_${item.nTypeID}`, item.nLeaveAmount);
                            form.setValue(`nVacaBringForward_${f.sID}_${item.nTypeID}`, item.nVacaBringForward);
                            form.setValue(`nVacaRemain_${f.sID}_${item.nTypeID}`, item.nLeaveRemain);
                        });
                    });
                    setDataRow({
                        ...dataRow,
                        arrRows: result.objResult.lstDataRow
                    });
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (err.nStatusCode === 409) {
                        DialogFn.Warning("กรุณาเลือกพนักงานที่ต้องการเพิ่มสิทธิ์การลา");
                    } else if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            }
        } else {
            DialogFn.Submit("คุณต้องการบันทึกข้อมูลใช่หรือไม่ ?", () => {
                AxiosFn.Post(`LeaveRights/OnSubmit`, param, (result) => {
                    DialogFn.Success("บันทึกสำเร็จ", () => {
                        navigate("/LeaveRights")
                    }, (err) => {
                        if (err.nStatusCode === 409) {
                            DialogFn.Warning(err.Message);
                        }
                    });
                });
            });
        }
        onClearForm();
    }

    const handleDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let arrClone = dataRow;
            let result = arrClone.arrRows.filter((f) => !e.includes(f.sID));
            arrClone.arrRows = arrClone.arrRows.filter((f) => e.includes(f.sID));

            if (arrClone.arrRows.length > 0) {
                arrClone.arrRows.forEach((f) => {
                    f.isDeleteDraft = true
                });
            }
            setDataRow({
                ...arrClone,
                arrRows: [...result.filter(f => !f.isDeleteDraft)],
                nDataLength: result.filter(f => !f.isDeleteDraft).length,
            });

            onClearForm();
            DialogFn.Success("ลบสำเร็จ", () => {
                console.log("dataRow.arrRows", dataRow.arrRows.filter((f) => f.isDeleteDraft))
            });
        });
    }

    const handleCheckYearAvilable = (e) => {
        let param = {
            nChooseDate: form.getValues("dYearPickerLeaveRights").valueOf()
        }

        AxiosFn.Post(`LeaveRights/OnCheckYearAvilable`, param, (result) => {
            if (result.nStatusCode === 200) {
                setDataRow({
                    ...dataRow,
                    arrRows: result.objResult.lstNewDataRow
                });

                let arrResult = [];
                arrResult = result.objResult.lstNewDataRow
                arrResult.forEach(f => {
                    f.lstLeaveType.forEach(item => {
                        form.setValue(`sUserName`, f.sUserName)
                        form.setValue(`nVacaBringForward_${f.sID}_2`, item.nVacaBringForward);
                    });
                });
            }
            onClearForm();
        }, (err) => {
            DialogFn.UnBlockUI();
            if (err.nStatusCode === 409) {
                form.reset();
                form.clearErrors();

                DialogFn.Warning("ปีนี้ถูกเลือกแล้ว กรุณาเลือกปีอื่น");
            } else if (!err.response) {
                DialogFn.Warning(err.sMessage);
                form.reset();
                form.clearErrors();
            }
        });
    }

    const handleFindBringNextYear = () => {
        let param = {
            lstUser: form.getValues("sUserNameSearch") === "" ? null : form.getValues("sUserNameSearch"),
            nChooseDate: form.getValues("dYearPickerLeaveRights").valueOf() === "" ? null : form.getValues("dYearPickerLeaveRights").valueOf(),
            lstDataRow: dataRow.arrRows,
        }

        AxiosFn.Post(`LeaveRights/OnFindBringNextYear`, param, (result) => {
            form.setValue("VacaLeaveDay", result.objResult.nTotalYear === 0 ? null : result.objResult.nTotalYear)
        }, (err) => {
            if (err.nStatusCode === 410) {
                onClearForm();
                DialogFn.Warning(err.sMessage);
            } else {
                DialogFn.Warning(err.sMessage);
            }
        });
    }

    useEffect(() => {
        const dataColumn = [...dataColumnSummary,
        //ป่วย สิทธิ์การลาที่ใช้ได้
        ...arrLeaveType.filter(f => f.value === 1).map((o) => {
            return {
                field: "nLeaveAmount_",
                headerName: "สิทธิ์การลาที่ใช้ได้ (วัน)",
                headerAlign: 'center',
                minWidth: 340,
                sortable: false,
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstLeaveType.find(s => s.nTypeID === (o.value === 1));
                    const isHaveType = itemData != null;
                    return (
                        <FormProvider {...form}>
                            {isHaveType ?
                                //ลาป่วย
                                <div style={{ display: "flex", flexDirection: "column", width: 410 }}>
                                    <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", width: "100%", gap: "10px" }}>
                                        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                            <Grid xs={12}>
                                                <InputNumberItem
                                                    id={"sLeaveRightsName"}
                                                    name={'nLeaveAmount_' + item.row.sID + '_1'} //สิทธิ์การลาใช้ได้
                                                    required={false}
                                                    disabled={!isPermission}
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                    <Grid xs={12}>
                                        <InputNumberItem
                                            id={"sLeaveRightsName"}
                                            name={'nLeaveAmount_' + item.row.sID + '_' + o.value} //สิทธิ์การลาใช้ได้
                                            required={false}
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                </div>
                            }
                        </FormProvider>
                    )
                }
            }
        }),
        //ป่วย คงเหลือ
        ...arrLeaveType.filter(f => f.value === 1).map((o) => {
            return {
                field: "nLeaveRemain_",
                headerName: "คงเหลือ (วัน)",
                headerAlign: 'center',
                minWidth: 340,
                sortable: false,
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstLeaveType.find(s => s.nTypeID === o.value);
                    const isHaveType = itemData != null;
                    return (
                        <FormProvider {...form}>
                            {isHaveType ?
                                //ลาป่วย
                                <div style={{ display: "flex", flexDirection: "column", width: 410 }}>
                                    <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", width: "100%", gap: "10px" }}>
                                        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                            <Grid xs={12}>
                                                <InputNumberItem
                                                    id={"sLeaveRightsName"}
                                                    name={'nLeaveRemain_' + item.row.sID + '_1'} //สิทธิ์การลาเหลือ
                                                    required={false}
                                                    disabled={!isPermission}
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                    <Grid xs={12}>
                                        <InputNumberItem
                                            id={"sLeaveRightsName"}
                                            name={'nLeaveRemain_' + item.row.sID + '_' + o.value} //สิทธิ์การลาเหลือ
                                            required={false}
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                </div>
                            }
                        </FormProvider>
                    )
                }
            }
        }),
        //พักผ่อน สิทธิ์การลาที่ใช้ได้
        ...arrLeaveType.filter(f => f.value === 2).map((o) => {
            return {
                field: "nVacaAmount_",
                headerName: "สิทธิ์การลาที่ใช้ได้ (วัน)",
                headerAlign: 'center',
                minWidth: 340,
                sortable: false,
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstLeaveType.find(s => s.nTypeID === o.value);
                    const isHaveType = itemData != null;
                    return (
                        <FormProvider {...form}>
                            {isHaveType ?
                                //ลาพักผ่อน
                                <div style={{ display: "flex", flexDirection: "column", width: 410 }}>
                                    <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", width: "100%", gap: "10px" }}>
                                        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                            <Grid xs={12}>
                                                <InputNumberItem
                                                    id={"sLeaveRightsName"}
                                                    name={'nVacaAmount_' + item.row.sID + '_2'} //พักร้อนใช้ได้
                                                    required={false}
                                                    disabled={!isPermission}
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                    <Grid xs={12}>
                                        <InputNumberItem
                                            id={"sLeaveRightsName"}
                                            name={'nVacaAmount_' + item.row.sID + '_' + 2} //พักร้อนใช้ได้
                                            required={false}
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                </div>
                            }
                        </FormProvider>
                    )
                }
            }
        }),
        //พักผ่อน สิทธิ์สมทบ
        ...arrLeaveType.filter(f => f.value === 2).map((o) => {
            return {
                field: "nVacaBringForward_",
                headerName: "สิทธิ์สมทบ (วัน)",
                headerAlign: 'center',
                minWidth: 340,
                sortable: false,
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstLeaveType.find(s => s.nTypeID === o.value);
                    const isHaveType = itemData != null;
                    return (
                        <FormProvider {...form}>
                            {isHaveType ?
                                //ลาพักผ่อน
                                <div style={{ display: "flex", flexDirection: "column", width: 410 }}>
                                    <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", width: "100%", gap: "10px" }}>
                                        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                            <Grid xs={12}>
                                                <InputNumberItem
                                                    id={"sLeaveRightsName"}
                                                    name={'nVacaBringForward_' + item.row.sID + '_2'} //พักร้อนสมทบ
                                                    required={false}
                                                    max={20}
                                                    validateMessage={"สิทธิ์ลาสมทบต้องไม่เกิน 20 วัน/ปี"}
                                                    disabled={!isPermission}
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                    <Grid xs={12}>
                                        <InputNumberItem
                                            id={"sLeaveRightsName"}
                                            name={'nVacaBringForward_' + item.row.sID + '_' + 2} //พักร้อนสมทบ
                                            required={false}
                                            validateMessage={"สิทธิ์ลาสมทบต้องไม่เกิน 20 วัน/ปี"}
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                </div>
                            }
                        </FormProvider>
                    )
                }
            }
        }),
        //พักผ่อน สิทธิ์สมทบ
        ...arrLeaveType.filter(f => f.value === 2).map((o) => {
            return {
                field: "nVacaRemain_",
                headerName: "คงเหลือ (วัน)",
                headerAlign: 'center',
                minWidth: 340,
                sortable: false,
                align: "center",
                renderCell: (item) => {
                    const itemData = item.row.lstLeaveType.find(s => s.nTypeID === o.value);
                    const isHaveType = itemData != null;
                    return (
                        <FormProvider {...form}>
                            {isHaveType ?
                                //ลาพักผ่อน
                                <div style={{ display: "flex", flexDirection: "column", width: 410 }}>
                                    <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", width: "100%", gap: "10px" }}>
                                        <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                            <Grid xs={12}>
                                                <InputNumberItem
                                                    id={"sLeaveRightsName"}
                                                    name={'nVacaRemain_' + item.row.sID + '_2'} //พักร้อนเหลือ
                                                    required={false}
                                                    disabled={!isPermission}
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div style={{ display: "flex", flex: 1, justifyContent: "center" }}>
                                    <Grid xs={12}>
                                        <InputNumberItem
                                            id={"sLeaveRightsName"}
                                            name={'nVacaRemain_' + item.row.sID + '_' + 2} //พักร้อนเหลือ
                                            required={false}
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                </div>
                            }
                        </FormProvider>
                    )
                }
            }
        }),
        ]

        setDataColumnLeave(dataColumn)
    }, [arrLeaveType, isEdit]);

    useEffect(() => {
        getTable(dataRow);
    }, []);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid item md={3} xs={6}>
                    <DatePickerItem
                        name={`dYearPickerLeaveRights`}
                        id={`dYearPickerLeaveRights`}
                        label={"สิทธิ์การลาประจำปี"}
                        IsYearPicker
                        minDate={moment()}
                        required={true}
                        onChange={(v) => { handleCheckYearAvilable(v) }}
                        disabled={isEdit}
                    />
                </Grid>

                <Grid item md={3} xs={5} sx={{ mt: "1.5%" }}>
                    <AutoCompleteItem
                        id={'sUserNameSearch'}
                        name={'sUserNameSearch'}
                        sUrlAPI={`LeaveRights/GetSearchEmployeeName?nYear=${nYear ?? 0}`}
                        label={'ชื่อ'}
                        required={false}
                        disabled={!isPermission}
                        fullWidth={false}
                        sx={{ width: "40%" }}
                        onBlur={() => { handleFindBringNextYear() }}
                    />
                </Grid>

                <Grid container xs={12} spacing={2} sx={{ mt: "0.5%" }}>
                    <Grid item md={3} xs={6}>
                        <InputNumberItem
                            id={"LeaveInsert"}
                            name={"LeaveInsert"}
                            label={"ลาป่วย (วัน)"}
                            required={false}
                            disabled={!isPermission}
                        />
                    </Grid>

                    <Grid item md={3} xs={6}>
                        <InputNumberItem
                            id={"VacaInsert"}
                            name={"VacaInsert"}
                            label={"ลาพักผ่อน (วัน)"}
                            required={false}
                            disabled={!isPermission}
                        />
                    </Grid>

                    <Grid item md={3} xs={6}>
                        <InputNumberItem
                            id={"VacaLeaveDay"}
                            name={"VacaLeaveDay"}
                            label={"ลาพักผ่อนสมทบ (วัน)"}
                            required={false}
                            max={20}
                            validateMessage={"สิทธิ์ลาสมทบต้องไม่เกิน 20 วัน/ปี"}
                            disabled={!isPermission}
                        />
                    </Grid>
                </Grid>

                <Grid item sx={{ mt: "1%" }}>
                    <BtnAdd id={"btnSave"} IsDisabled={!isPermission} onClick={form.handleSubmit((e) => { handleSubmit(e, 2) })} />
                </Grid>

                <Grid item xs={12} sx={{ mt: "2%" }}>
                    <DataGrid
                        sTableID='tableLeaveRightsForm'
                        columns={dataColumLeave}
                        rows={dataRow}
                        isLoading={loadingTable}
                        onLoadData={getTable}
                        isShowCheckBox={isPermission}
                        onRowSelectable={(p) => p.row.isCanDelete}
                        isHiddenToolHead
                        onDelete={handleDelete}
                        experimentalFeatures={{ columnGrouping: true }} //Grouping Header Column
                        columnGroupingModel={columnGroupingModel} //Grouping Header Column
                        isPin={false}
                        isHiddenPagination
                    />
                </Grid>

                <Grid item xs={12} sx={{ mt: "2%" }}>
                    <Grid item xs={12} sx={{ marginTop: "2%" }}>
                        <Typography>
                            {I18n.SetText("indicatorPage.status")}
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider sx={{ mb: "2%" }} />
                        <SwitchFormItem
                            id={'statusLeaveRights'}
                            name={"statusLeaveRights"}
                            disabled={!isPermission}
                        />
                    </Grid>
                </Grid>

                {/* Button */}
                <Grid item xs={12} >
                    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"start"} sx={{ display: "flex", my: "2%" }}>
                        <Grid item>
                            <BtnBack id={"addHoliday"} txt={"ย้อนกลับ"} onClick={() => { navigate("/LeaveRights"); }} />
                        </Grid>
                        <Grid item>
                            <BtnSave id={"btnSave"} IsDisabled={!isPermission} onClick={form.handleSubmit((e) => { handleSubmit(e, 1) })} />
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>
        </React.Fragment >
    );
}

export default LeaveRightsForm;